export default "__VITE_ASSET__71e02004__"